/* Lookup table exported so the product-deep-dive hero can
   pick the right Stage* component for a given product id
   without a hard-coded switch statement. */

import StageTheo from './StageTheo.jsx';
import StageCharts from './StageCharts.jsx';

export const STAGES = {
  theo: StageTheo,
  charts: StageCharts,
};
